import React from 'react';
import styles from './Tag.module.scss';

export type TagType = 'ACTIVE' | 'INACTIVE';

const tagStyles: Record<TagType, { color: string; backgroundColor: string; text: string }> = {
  INACTIVE: { color: '#6D7786', backgroundColor: 'rgb(226 232 239)', text: 'Inactive' },
  ACTIVE: { color: '#12B76A', backgroundColor: '#ECFDF3', text: 'Active' },
};

interface TagProps {
  type: TagType;
  onChange?: (tag: string) => void;
}

const Tag: React.FC<TagProps> = ({ type, onChange }) => {
  const style = tagStyles[type];

  const handleClick = () => {
    if (onChange) {
      onChange(type);
    }
  };

  return (
    <div
      className={styles.tag}
      style={{ backgroundColor: style.backgroundColor, color: style.color }}
      onClick={handleClick}
    >
      {style.text}
    </div>
  );
};

export default Tag;
